export function required(value: string): boolean {
    return !!value;
}

export function matches(value: string, match: string | number): boolean {
    return value === `${match}`;
}

export function matchesCaseInsensitive(value: string, match: string | number): boolean {
    return value.toLowerCase() === `${match}`.toLowerCase();
}

export function istrue(value: string): boolean {
    return value === 'true';
}

export function min(value: string, minimum: number): boolean {
    return parseInt(value) >= minimum;
}

export function max(value: string, maximum: number): boolean {
    return parseInt(value) <= maximum;
}

export function minlength(value: string, length: number): boolean {
    return `${value}`.length >= length;
}

export function maxlength(value: string, length: number): boolean {
    return `${value}`.length <= length;
}

export function alpha(value: string): boolean {
    return /^[A-Za-z]*$/.test(`${value || ''}`);
}

export function alphanumeric(value: string): boolean {
    return /^[A-Za-z0-9]*$/.test(`${value || ''}`);
}

export function radioIdVin(value: string): boolean {
    return !value || /^[A-Za-z0-9]{8,17}$/.test(value);
}

export function zipCode(value: string): boolean {
    return !value || /^\d{5}(-\d{4})?$/.test(value);
}

export function email(value: string): boolean {
    const rx = /^.+@.+\..{1,63}$/;
    return rx.test(value);
}

type ifValueHandler = (value: string) => boolean;
export function ifValue(value: string, handler: ifValueHandler) {
    if (!value) {
        return true;
    }

    return handler(value);
}

const regexCache = new Map<string, RegExp>();

export function regex(value: string, pattern: string): boolean {
    let rx = regexCache.get(pattern);
    if (!rx) {
        rx = new RegExp(pattern);
        regexCache.set(pattern, rx);
    }
    return rx.test(value);
}
